import React from "react";
import { View, Text, FlatList, StyleSheet } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import UserItem from "./ConnectUserItem";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";

type User = {
  userID: string;
  profilePicture: string;
  isSelected: number;
};

type GroupedUsers = {
  firstChar: string;
  users: User[];
};

type UserListProps = {
  data: GroupedUsers[];
  onSelect: (index: number, subIndex: number) => void;
};

const ConnectUserList: React.FC<UserListProps> = ({ data, onSelect }) => {
  const renderDataItem = ({
    item,
    index,
  }: {
    item: GroupedUsers;
    index: number;
  }) => (
    <View style={styles.groupContainer} key={index}>
      <View style={styles.groupHeader}>
        <Text style={[AppFontStyle.BOLD_ANYBODY_10, styles.groupHeaderText]}>
          {item.firstChar}
        </Text>
      </View>
      {item.users.map((user, subIndex) => (
        <UserItem
          key={subIndex}
          user={user}
          onSelect={() => onSelect(index, subIndex)}
        />
      ))}
    </View>
  );

  return (
    <FlatList
      data={data}
      renderItem={renderDataItem}
      keyExtractor={(item, index) => index.toString()}
    />
  );
};

const styles = StyleSheet.create({
  groupContainer: {
    marginBottom: 10,
  },
  groupHeader: {
    marginVertical: 20,
  },
  groupHeaderText: {
    paddingBottom: 5,
  },
});

export default withErrorBoundary(ConnectUserList);
